import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { WeScreen } from '@/components/WeScreen/WeScreen'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useRedirectBasedOnPermissions } from '@/hooks/useRedirectBasedOnPermissions'

import { ReportsTab } from './Components/ReportsTab'
import { DeletedReportsTab } from './Components/DeletedReportsTab'

export const ReportsScreen = () => {
  const { t } = useTranslation()
  const { hasViewReports } = useRedirectBasedOnPermissions()
  const [activeTab, setActiveTab] = useState('available')

  useEffect(() => {
    hasViewReports()
  }, [hasViewReports])

  return (
    <WeScreen childrenCustomGap={20} useHeader={false}>
      <Tabs
        defaultValue="available"
        onValueChange={(val) => {
          setActiveTab(val)
        }}
        className="w-full h-full flex flex-col gap-5"
      >
        <TabsList className="w-full bg-transparent justify-start border-b border-primaryColor30 p-0 rounded-none">
          <TabsTrigger
            value="available"
            className="hover:cursor-pointer w-min max-md:w-full border-x-0 border-t-0 rounded-none bg-transparent data-[state=active]:bg-transparent data-[state=active]:text-primaryColor data-[state=active]:font-bold data-[state=active]:border-b-primaryColor data-[state=active]:shadow-none font-semibold text-neutralColor80 data-[state=inactive]:border-none"
          >
            {t('dashboard.reports.tabs.available')}
          </TabsTrigger>
          <TabsTrigger
            value="expired"
            className="hover:cursor-pointer w-min max-md:w-full border-x-0 border-t-0 rounded-none bg-transparent data-[state=active]:bg-transparent data-[state=active]:text-primaryColor data-[state=active]:font-bold data-[state=active]:border-b-primaryColor data-[state=active]:shadow-none font-semibold text-neutralColor80 data-[state=inactive]:border-none"
          >
            {t('dashboard.reports.tabs.expired')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="available" className="flex-1 min-h-0">
          <ReportsTab isActive={activeTab === 'available'} />
        </TabsContent>

        <TabsContent value="expired" className="flex-1 min-h-0">
          <DeletedReportsTab isActive={activeTab === 'expired'} />
        </TabsContent>
      </Tabs>
    </WeScreen>
  )
}
